import React from 'react';
//ui library
import {Container, Grid, withStyles} from '@material-ui/core';
//styles
import styles from './groups-styles';
//components
import GroupItem from '../../../components/groups/group-item';
import PageHeading from '../../../components/page-heading';
//lib
import { withRouter } from 'react-router-dom';

const GroupsView = (props) => {
  const {classes, isLoading, groups, history} = props;

  const navigate = (groupId) => {
    history.push(`group/${groupId}`);
  };

  return (
    <Container maxWidth={'md'}>
      <PageHeading heading={'Groups'}/>

      <Grid container>
        <Grid container spacing={2}>
          {
            !isLoading && groups.length > 0 && groups.map((g, i) =>
              <Grid key={i} item xs={12} sm={4}>
                <GroupItem
                  group={g}
                  navigate={navigate}/>
              </Grid>)
          }

          {
            isLoading &&
            <>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><GroupItem isLoading/></Grid>
            </>
          }
        </Grid>

        {
          !isLoading && groups.length === 0 &&
          <div className={classes.noGroups}>
            No Groups to show
          </div>
        }
      </Grid>
    </Container>
  );
};

export default withRouter(withStyles(styles) (GroupsView));
